const IF = require( "infrontjs" );

import template from './TokenTemplate.html';

export class TokenState extends IF.State
{
    static ROUTE = '/token/:tokenId';
    static ID = 'token';

    canEnter()
    {
        return true;
    }

    async enter()
    {
        this.app.gui.showLoader();

        this.app.container.innerHTML = template;

        let response = await this.app.api.get( '/auth/token/' + this.routeParams.getParam( 'tokenId' ) );
        let responseStatus = response && response.status ? response.status : 500;
        let tokenAction = null;

        if ( 200 === responseStatus )
        {
            response = await response.json();
            tokenAction = response.action;
            switch ( tokenAction )
            {
                case 'validateEmail':
                    this.performEmailValidation( this.routeParams.getParam( 'tokenId' ) );
                break;

                case 'requestPasswordReset':
                    this.showPasswordResetForm();
                break;
            }
        }
        else
        {
            let errTitle = 'Verarbeitung fehlgeschlagen,',
                errMsg = 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.';
            switch ( responseStatus )
            {
                case 404:
                    errTitle = 'Nicht gefunden'
                    errMsg = 'Der übergebene Token wurde nicht gefunden. Entweder exisitert er nicht oder du hast die Aktion bereits aufgerufen.';
                    break;

                case 410:
                    errTitle = 'Abgelaufen';
                    errMsg = 'Der übergebene Token ist abgelaufen.';
                    break;
            }

            this.showError( errTitle, errMsg );
        }

        this.app.gui.hideLoader();
    }

    async performEmailValidation( tokenId )
    {
        this.app.container.querySelector( '[data-id="headline"]' ).innerHTML = 'Registration wird abgeschlossen...';
        const response = await this.app.api.put(  '/auth/token/' + this.routeParams.getParam( 'tokenId' ) );
        const responseStatus = response && response.status ? response.status : 500;
        if ( 200 === responseStatus )
        {
            this.app.container.querySelector( 'section[data-id="email-validation-success"]' ).classList.remove( 'hidden' );
        }
        else
        {
            this.showError("Oooops!", "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut." );
        }
    }

    showPasswordResetForm()
    {
        this.app.container.querySelector( '[data-id="set-new-password-form"]' ).classList.remove( 'hidden' );
        this.app.container.querySelector( '[data-id="btnSaveNewPassword"]' ).addEventListener( 'click', async () =>
        {
            const form = this.app.container.querySelector( 'form[data-id="new-password-form"]' );
            form.classList.add( 'validated' );
            if ( true === form.checkValidity() )
            {
                this.app.gui.showLoader();
                const formData = IF.Helper.serializeForm( form );

                let response = null;
                try
                {
                    response = await this.app.api.put(
                        '/auth/token/' + this.routeParams.getParam( 'tokenId' ),
                        formData
                    );
                }
                catch( e )
                {
                    response = null;
                }

                this.app.container.querySelector( '[data-id="set-new-password-form"]' ).classList.add( 'hidden' );

                if ( response && 200 === response.status )
                {
                    // Show Success screen
                    this.app.container.querySelector( '[data-id="set-new-password-success"]' ).classList.remove( 'hidden' );
                }
                else
                {
                    this.showError(
                        'Fehler',
                        'Ein Fehler ist aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt erneut'
                    );
                }

                this.app.gui.hideLoader();
            }
        });
    }

    showError( headline, message )
    {
        const processingErrorContainer = this.app.container.querySelector( '[data-id="processing-error"]' );
        processingErrorContainer.querySelector( '[data-id="headline"]' ).innerHTML = headline;
        processingErrorContainer.querySelector( '[data-id="content"]' ).innerHTML = message;
        processingErrorContainer.classList.remove( 'hidden' );
    }

    async exit()
    {
    }
};
